module.exports = __webpack_public_path__ + "static/img/active1.609b7aa1.png";